export default { 
	index: { method: 'get', url: 'log-access-routes' }, 
	store: { method: 'post', url: 'log-access-routes' }, 
	update: { method: 'put', url: 'log-access-routes/{id}' }, 
	destroy: { method: 'delete', url: 'log-access-routes/{id}' },
}
